import React from 'react';
import { FaRobot } from 'react-icons/fa';
import CommentThread from './CommentThread';
import CommentForm from './CommentForm';

function PostDetail({ post, onLike, onDislike, onBack }) {
  return (
    <div style={{ backgroundColor: '#f9f9f9', padding: '2rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{ backgroundColor: '#ffffff', padding: '2rem', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0,0,0,0.05)', width: '100%', maxWidth: '700px' }}>
        <button onClick={onBack} style={{ marginBottom: '1rem' }}>⬅ Back to posts</button>

        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
          {post.mediaUrl && post.mediaType.startsWith('image') && (
            <img src={post.mediaUrl} alt="Post media" style={{ width: '160px', height: '160px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }} />
          )}
          {post.mediaUrl && post.mediaType.startsWith('video') && (
            <video controls style={{ width: '160px', height: '160px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }}>
              <source src={post.mediaUrl} type={post.mediaType} />
            </video>
          )}

          <div style={{ flex: 1 }}>
            <h2>{post.title}</h2>
            <p style={{ fontStyle: 'italic', fontSize: '0.95rem', color: '#555' }}>
              Posted by {post.authorName || 'User'}
            </p>
            <p>{post.content}</p>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>Likes: {post.likes}</p>
            <div>
              <button onClick={() => onLike(post._id)} style={{ marginRight: '0.5rem' }}>👍 Like</button>
              <button onClick={() => onDislike(post._id)}>👎 Dislike</button>
            </div>
          </div>
        </div>

        {post.botReply && (
          <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f1f7ff', borderRadius: '8px', border: '1px solid #cce0ff' }}>
            <strong><FaRobot className="robot-icon" /> TJG Bot says:</strong>
            <p>{post.botReply}</p>
          </div>
        )}

        <CommentThread comments={post.comments} />
        <CommentForm postId={post._id} subscriberId={post.author} onCommentAdded={() => onBack()} />
      </div>
    </div>
  );
}

export default PostDetail;







// import React from 'react';
// import { FaRobot } from 'react-icons/fa';
// import CommentThread from './CommentThread';
// import CommentForm from './CommentForm';

// function PostDetail({ post, onLike, onDislike, onBack }) {
//   return (
//     <div style={{ backgroundColor: '#f9f9f9', padding: '2rem', display: 'flex', justifyContent: 'center' }}>
//       <div style={{ backgroundColor: '#ffffff', padding: '2rem', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0,0,0,0.05)', width: '100%', maxWidth: '700px' }}>
//         <button onClick={onBack} style={{ marginBottom: '1rem' }}>⬅ Back to posts</button>

//         <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
//           {post.mediaUrl && post.mediaType.startsWith('image') && (
//             <img src={post.mediaUrl} alt="Post media" style={{ width: '160px', height: '160px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }} />
//           )}
//           {post.mediaUrl && post.mediaType.startsWith('video') && (
//             <video controls style={{ width: '160px', height: '160px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }}>
//               <source src={post.mediaUrl} type={post.mediaType} />
//             </video>
//           )}

//           <div style={{ flex: 1 }}>
//             <h2>{post.title}</h2>
//             <p>{post.content}</p>
//             <p style={{ fontSize: '0.9rem', color: '#666' }}>Likes: {post.likes}</p>
//             <div>
//               <button onClick={() => onLike(post._id)} style={{ marginRight: '0.5rem' }}>👍 Like</button>
//               <button onClick={() => onDislike(post._id)}>👎 Dislike</button>
//             </div>
//           </div>
//         </div>

//         {post.botReply && (
//           <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f1f7ff', borderRadius: '8px', border: '1px solid #cce0ff' }}>
//             <strong><FaRobot className="robot-icon" /> TJG Bot says:</strong>
//             <p>{post.botReply}</p>
//           </div>
//         )}

//         {/* Comments Section */}
//         <CommentThread comments={post.comments} />
//         <CommentForm postId={post._id} subscriberId={post.author} onCommentAdded={() => onBack()} />
//       </div>
//     </div>
//   );
// }

// export default PostDetail;














// import React from 'react';
// import { FaRobot } from 'react-icons/fa';

// function PostDetail({ post, onLike, onDislike, onBack }) {
//   return (
//     <div
//       style={{
//         backgroundColor: '#f9f9f9',
//         padding: '2rem',
//         display: 'flex',
//         justifyContent: 'center'
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: '#ffffff',
//           padding: '2rem',
//           borderRadius: '12px',
//           boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
//           width: '100%',
//           maxWidth: '700px'
//         }}
//       >
//         <button onClick={onBack} style={{ marginBottom: '1rem' }}>
//           ⬅ Back to posts
//         </button>

//         <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
//           {/* Media on the side */}
//           {post.mediaUrl && post.mediaType.startsWith('image') && (
//             <img
//               src={post.mediaUrl}
//               alt="Post media"
//               style={{
//                 width: '160px',
//                 height: '160px',
//                 objectFit: 'cover',
//                 borderRadius: '8px',
//                 flexShrink: 0
//               }}
//             />
//           )}

//           {post.mediaUrl && post.mediaType.startsWith('video') && (
//             <video
//               controls
//               style={{
//                 width: '160px',
//                 height: '160px',
//                 objectFit: 'cover',
//                 borderRadius: '8px',
//                 flexShrink: 0
//               }}
//             >
//               <source src={post.mediaUrl} type={post.mediaType} />
//             </video>
//           )}

//           {/* Post content */}
//           <div style={{ flex: 1 }}>
//             <h2 style={{ marginBottom: '0.5rem' }}>{post.title}</h2>
//             <p style={{ fontSize: '1rem', color: '#444', marginBottom: '1rem' }}>{post.content}</p>
//             <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
//               Likes: {post.likes}
//             </p>
//             <div>
//               <button
//                 onClick={() => onLike(post._id)}
//                 style={{
//                   marginRight: '0.5rem',
//                   padding: '0.4rem 0.8rem',
//                   backgroundColor: '#0a66c2',
//                   color: '#fff',
//                   border: 'none',
//                   borderRadius: '4px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 👍 Like
//               </button>
//               <button
//                 onClick={() => onDislike(post._id)}
//                 style={{
//                   padding: '0.4rem 0.8rem',
//                   backgroundColor: '#e0e0e0',
//                   color: '#333',
//                   border: 'none',
//                   borderRadius: '4px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 👎 Dislike
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Auto bot comment */}
//         {post.botReply && (
//           <div
//             style={{
//               marginTop: '1.5rem',
//               padding: '1rem',
//               backgroundColor: '#f1f7ff',
//               borderRadius: '8px',
//               border: '1px solid #cce0ff'
//             }}
//           >
//             <strong><FaRobot className="robot-icon" /> TJG Bot says:</strong>
//             <p style={{ marginTop: '0.5rem' }}>{post.botReply}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default PostDetail;






// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// function PostDetail({ post, onLike, onDislike, onBack }) {
//   const [botResponse, setBotResponse] = useState(null);

//   useEffect(() => {
//     const shouldAskBot = post.content.trim().endsWith('?') || post.content.trim().endsWith('.');

//     if (shouldAskBot) {
//       const prompt = post.content.trim();
//       getBotReply(prompt);
//     }
//   }, [post]);

//   const getBotReply = async (prompt) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/`, {
//         text: prompt,
//         from: 'auto-forum',
//         sessionId: 'auto-comment-bot'
//       });

//       setBotResponse(res.data.response);
//     } catch (err) {
//       console.error('Bot auto-comment failed:', err);
//     }
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: '#f9f9f9',
//         padding: '2rem',
//         display: 'flex',
//         justifyContent: 'center'
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: '#ffffff',
//           padding: '2rem',
//           borderRadius: '12px',
//           boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
//           width: '100%',
//           maxWidth: '700px'
//         }}
//       >
//         <button onClick={onBack} style={{ marginBottom: '1rem' }}>
//           ⬅ Back to posts
//         </button>

//         <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
//           {/* Media on the side */}
//           {post.mediaUrl && post.mediaType.startsWith('image') && (
//             <img
//               src={post.mediaUrl}
//               alt="Post media"
//               style={{
//                 width: '160px',
//                 height: '160px',
//                 objectFit: 'cover',
//                 borderRadius: '8px',
//                 flexShrink: 0
//               }}
//             />
//           )}

//           {post.mediaUrl && post.mediaType.startsWith('video') && (
//             <video
//               controls
//               style={{
//                 width: '160px',
//                 height: '160px',
//                 objectFit: 'cover',
//                 borderRadius: '8px',
//                 flexShrink: 0
//               }}
//             >
//               <source src={post.mediaUrl} type={post.mediaType} />
//             </video>
//           )}

//           {/* Post content */}
//           <div style={{ flex: 1 }}>
//             <h2 style={{ marginBottom: '0.5rem' }}>{post.title}</h2>
//             <p style={{ fontSize: '1rem', color: '#444', marginBottom: '1rem' }}>{post.content}</p>
//             <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
//               Likes: {post.likes}
//             </p>
//             <div>
//               <button
//                 onClick={() => onLike(post._id)}
//                 style={{
//                   marginRight: '0.5rem',
//                   padding: '0.4rem 0.8rem',
//                   backgroundColor: '#0a66c2',
//                   color: '#fff',
//                   border: 'none',
//                   borderRadius: '4px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 👍 Like
//               </button>
//               <button
//                 onClick={() => onDislike(post._id)}
//                 style={{
//                   padding: '0.4rem 0.8rem',
//                   backgroundColor: '#e0e0e0',
//                   color: '#333',
//                   border: 'none',
//                   borderRadius: '4px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 👎 Dislike
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Auto bot comment */}
//         {botResponse && (
//           <div
//             style={{
//               marginTop: '1.5rem',
//               padding: '1rem',
//               backgroundColor: '#f1f7ff',
//               borderRadius: '8px',
//               border: '1px solid #cce0ff'
//             }}
//           >
//             <strong>🤖 TJG Bot says:</strong>
//             <p style={{ marginTop: '0.5rem' }}>{botResponse}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default PostDetail;




// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// function PostDetail({ post, onLike, onDislike, onBack }) {
//   const [botResponse, setBotResponse] = useState(null);

//   useEffect(() => {
//     const shouldAskBot = post.content.trim().endsWith('?') || post.content.trim().endsWith('.');

//     if (shouldAskBot) {
//       const prompt = post.content.trim();
//       getBotReply(prompt);
//     }
//   }, [post]);

//   const getBotReply = async (prompt) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/`, {
//         text: prompt,
//         from: 'auto-forum',
//         sessionId: 'auto-comment-bot' // can be any static sessionId
//       });

//       setBotResponse(res.data.response);
//     } catch (err) {
//       console.error('Bot auto-comment failed:', err);
//     }
//   };

//   return (
//     <div>
//       <button onClick={onBack}>Back to posts</button>
//       <h2>{post.title}</h2>
//       <p>{post.content}</p>

//       {post.mediaUrl && post.mediaType.startsWith('image') && (
//         <img src={post.mediaUrl} alt="Post media" style={{ maxWidth: '100%' }} />
//       )}

//       {post.mediaUrl && post.mediaType.startsWith('video') && (
//         <video controls style={{ maxWidth: '100%' }}>
//           <source src={post.mediaUrl} type={post.mediaType} />
//         </video>
//       )}

//       <p>Likes: {post.likes}</p>
//       <button onClick={() => onLike(post._id)}>Like</button>
//       <button onClick={() => onDislike(post._id)}>Dislike</button>

//       {/* Auto bot comment */}
//       {botResponse && (
//         <div style={{ marginTop: '1rem', padding: '1rem', border: '1px solid #ccc', borderRadius: '5px' }}>
//           <strong>🧠 TJG Bot:</strong>
//           <p>{botResponse}</p>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PostDetail;



// import React from 'react';

// function PostDetail({ post, onLike, onDislike, onBack }) {
//   return (
//     <div>
//       <button onClick={onBack}>Back to List</button>
//       <h3>{post.title}</h3>
//       <p>{post.content}</p>

//       {post.mediaUrl && (
//         post.mediaType.startsWith('image') ? (
//           <img src={post.mediaUrl} alt="Post media" style={{ width: '100%', margin: '1rem 0' }} />
//         ) : (
//           <video controls style={{ width: '100%', margin: '1rem 0' }}>
//             <source src={post.mediaUrl} type={post.mediaType} />
//             Your browser does not support the video tag.
//           </video>
//         )
//       )}

//       <div style={{ display: 'flex', alignItems: 'center', margin: '1rem 0' }}>
//         <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>❤️</span>
//         <span>{post.likes}</span>
//       </div>
//       <div>
//         <button onClick={() => onLike(post._id)} style={{ marginRight: '1rem' }}>
//           👍 Like
//         </button>
//         <button onClick={() => onDislike(post._id)}>👎 Dislike</button>
//       </div>
//     </div>
//   );
// }

// export default PostDetail;


// function PostDetail({ post, onLike, onDislike, onBack }) {
//   return (
//     <div>
//       <button onClick={onBack}>Back to List</button>
//       <h3>{post.title}</h3>
//       <p>{post.content}</p>
//       <div style={{ display: 'flex', alignItems: 'center', margin: '1rem 0' }}>
//         {/* Heart icon and like counter */}
//         <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>❤️</span>
//         <span>{post.likes}</span>
//       </div>
//       <div>
//         {/* Thumbs up to like and thumbs down to dislike */}
//         <button onClick={() => onLike(post._id)} style={{ marginRight: '1rem' }}>
//           👍 Like
//         </button>
//         <button onClick={() => onDislike(post._id)}>
//           👎 Dislike
//         </button>
//       </div>
//     </div>
//   );
// }

// export default PostDetail;




// import React from 'react';
// import CommentForm from './CommentForm';

// function PostDetail({ post, onLike, onForward, onBack }) {
//   return (
//     <div>
//       <button onClick={onBack}>Back to Posts</button>
//       <h3>{post.title}</h3>
//       <p>{post.content}</p>
//       <button onClick={() => onLike(post._id)}>Like / Unlike</button>
//       <button onClick={() => onForward(post._id)}>Forward</button>
//       <CommentForm post={post} />
//     </div>
//   );
// }

// export default PostDetail;
